import type { Dayjs } from 'dayjs'
import { useAtom } from 'jotai'

import type { ISODateString } from '@/types'
import ErrorBox from '@/components/error-box'
import LoadingBox from '@/components/loading-box'
import { selectedCollectionPointIdAtom } from '@/state'
import { useCollectionPointWeightings } from '@/hooks/api/use-collection-point'
import DisposalTrendMonthlyTrend from './monthly-trend'

export default function DisposalTrendMonthlyTrendLoader({
    endDate,
}: {
    endDate: Dayjs
}) {
    const [collectionPointId] = useAtom(selectedCollectionPointIdAtom)

    const startOfPreviousYear = endDate.subtract(1, 'year').startOf('year')
    const endOfCurrentYear = endDate.endOf('year')

    const { status, data, error } = useCollectionPointWeightings(
        collectionPointId,
        startOfPreviousYear.format('YYYY-MM-DD') as ISODateString,
        endOfCurrentYear.format('YYYY-MM-DD') as ISODateString
    )

    if (status === 'pending') {
        return <LoadingBox />
    }

    if (error) {
        return (
            <ErrorBox
                error={error}
                message={`Nepovedlo se načíst statistiky výsypu svozového místa ID ${collectionPointId}`}
            />
        )
    }

    return (
        <DisposalTrendMonthlyTrend
            data={data}
            endDate={endDate}
        />
    )
}
